/* ESSE ARQUIVO SERA EXCLUIDO APOS INTEGRACAO OFICIAL COM BACKEND */

import { INotificationRead } from "../model/INotifications";

const FAKE_USERS = [
  { name: "João Silva", email: "joao.silva@cliente.com" },
  { name: "Maria Souza", email: "maria.souza@cliente.com" },
  { name: "Carlos Pereira", email: "carlos.pereira@cliente.com" },
  { name: "Ana Lima", email: "ana.lima@cliente.com" },
];

const randomInt = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const generateMockReads = (): INotificationRead[] => {
  const count = randomInt(1, FAKE_USERS.length); // entre 1 e 4 lidos
  const now = new Date();

  return FAKE_USERS.slice(0, count).map((u, index) => ({
    name: u.name,
    email: u.email,
    readAt: new Date(
      now.getTime() - (index + 1) * 60 * 60 * 1000 // há X horas atrás
    ).toISOString(),
  }));
};
